import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'msTime' })
export class MsTimePipe implements PipeTransform {
  public transform(ms: number): any {
    const days = Math.floor(ms / (24 * 60 * 60 * 1000));
    const daysms = ms % (24 * 60 * 60 * 1000);
    const hours = Math.floor(daysms / (60 * 60 * 1000));
    const hoursms = ms % (60 * 60 * 1000);
    const minutes = Math.floor(hoursms / (60 * 1000));
    const minutesms = ms % (60 * 1000);
    const sec = Math.floor(minutesms / 1000);
    if (days) {
      return days + ' days ' + hours + 'h ' + minutes + 'm';
    }
    if (hours) {
      return hours + 'h ' + minutes + 'm';
    }
    if (minutes) {
      return minutes + 'm ' + sec + 's';
    }
    return sec + 's';

  }
}
